import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UserService } from '../../services/user/user.service';
import { JsonDataService } from '../../services/commonData/json-data.service';
import { SessionStorageService } from 'ngx-webstorage';
import { ErrorHandlingService } from '../../services/error-handling/error-handling.service';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

@Component({
  selector: 'ap-navigation',
  standalone: true,
  templateUrl: './navigation.component.html',
  imports: [CommonModule, NgbDropdownModule]
})
export class NavigationComponent implements AfterViewInit, OnInit, OnDestroy {
  userName: string = '';
  bln_editMode: boolean = false;
  checkForEdit: any;
  bln_idAdmin: any;
  logo: any;
  bln_isLdap: any;
  showSidebar:boolean=false;
  public config: PerfectScrollbarConfigInterface = {};
  roleName: any;
  constructor(
    public router: Router,
    private sessionStorage: SessionStorageService,
    public userService: UserService,
    private jsonService?: JsonDataService,
    private errorHandling?: ErrorHandlingService
  ) {
    this.jsonService?.getValueFromJSON().then((res: any) =>
    {
       var str_projectName = res.ProjectName?.[0]?.Name;
      var str_logohome = res.logoChanges[2].logoSidebar;
      this.logo = `assets/images/${str_projectName}/${str_logohome}`;
      this.bln_isLdap = res.Ldap[0].Value;
    }).catch((err:any) =>
    {
      console.log(err);
      this.errorHandling?.checkError(500);
    });

    this.userName = this.sessionStorage.retrieve("username");
    this.roleName = this.sessionStorage.retrieve("userrole");
    if (this.roleName == "SuperAdmin")
    {
      this.bln_idAdmin = 1;
    }
  }

  logOut()
  {
    this.userService.logOut(1);
  }
  goHome() {
  this.router.navigate(['/home']);
}


  viewProfile()
  {
    this.router.navigate(['view-profile']);
  }

  changeProfile()
  {
    this.router.navigate(['admin-change-profile']);
  }

  ngOnInit()
  {
    this.sessionStorage.store('EditMode', false);
    this.checkForEdit = setInterval(() =>
    {
      this.bln_editMode = this.sessionStorage.retrieve('EditMode');
    }, 1000);
  }

  
  ngOnDestroy()
  {
    clearInterval(this.checkForEdit);
  }

  // This is for Notifications
  notifications: Object[] = [
    {
      round: "round-danger",
      icon: "ti-link",
      title: "Luanch Admin",
      subject: "Just see the my new admin!",
      time: "9:30 AM"
    },
    {
      round: "round-success",
      icon: "ti-calendar",
      title: "Event today",
      subject: "Just a reminder that you have event",
      time: "9:10 AM"
    },
    {
      round: "round-info",
      icon: "ti-settings",
      title: "Settings",
      subject: "You can customize this template as you want",
      time: "9:08 AM"
    },
    {
      round: "round-primary",
      icon: "ti-user",
      title: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM"
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: "assets/images/users/1.jpg",
      status: "online",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:30 AM"
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "busy",
      from: "Sonu Nigam",
      subject: "I have sung a song! See you at",
      time: "9:10 AM"
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "away",
      from: "Arijit Sinh",
      subject: "I am a singer!",
      time: "9:08 AM"
    },
    {
      useravatar: "assets/images/users/4.jpg",
      status: "offline",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM"
    }
  ];


  ngAfterViewInit()
  {
    var set = function (this: any)
    {
      var width = window.innerWidth > 0 ? window.innerWidth : this.screen.width;
      var topOffset = 0;
      if (width < 1170)
      {
        $("#main-wrapper").addClass("mini-sidebar");
      } else
      {
        $("#main-wrapper").removeClass("mini-sidebar");
      }
    };
    $(window).ready(set);
    $(window).on("resize", set);

    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function ()
      {
        $(".app-search").toggle(200);
      }
    );

    $("body").trigger("resize");
  }
  clickBreadcrumb() {
  this.showSidebar = !this.showSidebar;  // toggle
}
  
}

